import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useQuery } from 'modules/core/hooks/useQuery'
import { UniversalUpdaterEmployeesDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const UniversalUpdaterEmployeesPage = () => {
  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(UniversalUpdaterEmployeesDocument, {
    variables: { companyId: company.id },
  })

  const hasDevUniversalUpdaterEmployeesFeature =
    data?.features.featuresConnection.edges.find(
      (feature) => feature.node.name === 'dev_universal_updater_employees'
    )?.node.enabled ?? false
  const canImportResources = data?.universalImporter._policies.importResources.can ?? false
  const isAuthorized = hasDevUniversalUpdaterEmployeesFeature && canImportResources

  return (
    <ResponsivePage.Body
      authorized={isAuthorized}
      loading={loading}
      error={error}
      showHeader={false}
    >
      UniversalUpdaterEmployeesPage
    </ResponsivePage.Body>
  )
}

export default UniversalUpdaterEmployeesPage
